import React from "react";
import { Link } from "react-router-dom";
import "./sample.css";
import { getPathWithParam } from "../../../utils";

function RACTile(props) {
  const tileheight = props.height ? props.height : "auto";
  return (
    <div
      style={{ height: tileheight }}
      className="border mapper-ractile mapper-raccontainer-griditem h-100"
    >
      <div className="d-flex" style={{ marginBottom: "1.063rem" }}>
        <p
          style={{ color: "grey", fontSize: "14px", fontWeight: "bold" }}
          className="p-0 m-0 bg-inherit"
        >
          {props.title ? props.title : "Title not found"}
        </p>
        {props.mapType == 2 || props.mapType == 3 || props.title != "Target" ? (
          <>
            <Link to={props.tileRoute} className="ml-auto">
              {" "}
              <i style={{ height: "16px" }} className="fas fa-edit"></i>
            </Link>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="mapper-ractile-children">{props.children}</div>
    </div>
  );
}

export default RACTile;
